import { track } from '@/shared/analytics';
import { router } from './router';

function trackPushOpened(pushType: string) {
  track('push_opened', { source: 'push', label: pushType });
}

/** Переход по клику на пуш: воркер просит открытое приложение сменить экран */
export function listenPushNavigation() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.addEventListener('message', (event) => {
    const data = event.data as {
      type?: string;
      url?: string;
      pushType?: string;
    } | null;
    if (data?.type !== 'NAVIGATE' || !data.url) return;

    // Ответ говорит воркеру, что переход берём на себя
    event.ports[0]?.postMessage({ ok: true });
    if (data.pushType) trackPushOpened(data.pushType);
    router.navigate(data.url).catch((err) => console.error('[push]', err));
  });
}

/**
 * Приложение открыто тапом по пушу: воркер дописал тип в ?push=.
 * Параметр убираем, иначе перезагрузка засчитала бы переход ещё раз
 */
export function trackPushOpenedFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const pushType = params.get('push');
  if (!pushType) return;

  trackPushOpened(pushType);
  params.delete('push');
  const search = params.toString();
  router
    .navigate(
      {
        pathname: window.location.pathname,
        search: search ? `?${search}` : '',
      },
      { replace: true }
    )
    .catch((err) => console.error('[push]', err));
}
